export default __webpack_public_path__ + "static/media/rphs.e0aee9ba.jpeg";